import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/detailQrcode.jpeg';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-cf80e3ee"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "text"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", null, "免责申明", -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, " 为保障竞赛公益、自愿、普及等原则，赛事组委会的技术支持单位为每一位参赛学生提供免费在线编程普及课程，用于学生学习编程基础知识。为避免权属纠纷，特做以下说明： ", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, " 1.网上学习课程以“微信群辅导”的形式完成，技术支持单位提供的所有学习内容均在微信群内，不会通过其他形式呈现，请不要相信其他任何形式的赛事辅导学习课程。 ", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, " 2.技术支持单位提供的免费在线编程普及课程是为提升学生编程素养，让每一位学生更好参与编程比赛而设置，所有学习内容与学习过程皆自愿参与，不做任何强制要求。 ", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, " 3.除免费在线编程普及课程外的其他任何内容不在本次比赛活动范围内，请家长慎重了解，自愿选择是否参与。 ", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, " 4.在申请免费在线编程普及课程过程中，不会收集个人的姓名、手机号、微信号、身份证号、家庭住址等私人信息，如果有出现其他搜集家长、学生和老师的此类个人私人信息或其他信息的，请家长和老师慎重了解，自愿选择是否参与。 ", -1);
});
var _hoisted_8 = {
  class: "btn"
};
var _hoisted_9 = /*#__PURE__*/_createTextVNode("不同意");
var _hoisted_10 = /*#__PURE__*/_createTextVNode("同意");
var _hoisted_11 = {
  key: 1,
  class: "code"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", null, "微信扫码参与赛前科普课程", -1);
});
var _hoisted_14 = [_hoisted_12, _hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.showFlag,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.showFlag = $event;
    }),
    closable: _ctx.showCloseIcon,
    "destroy-on-close": true,
    "mask-closable": false,
    width: _ctx.showQrcodeStatus ? 400 : 600,
    title: null,
    footer: null,
    class: "login-dialog",
    onCancel: _ctx.cancel
  }, {
    default: _withCtx(function () {
      return [!_ctx.showQrcodeStatus ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
        class: "btn-item",
        rel: "noopener",
        type: "primary",
        shape: "round",
        onClick: _ctx.disagree
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        class: "btn-item",
        rel: "noopener",
        type: "primary",
        shape: "round",
        onClick: _ctx.showCode
      }, {
        default: _withCtx(function () {
          return [_hoisted_10];
        }),
        _: 1
      }, 8, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))];
    }),
    _: 1
  }, 8, ["visible", "closable", "width", "onCancel"]);
}